export enum DEVICE {
    ALL = 'ALL',
    DESKTOP = 'DESKTOP',
    MOBILE = 'MOBILE',
}
